<template>
  <div>
    <v-dialog v-model="value" max-width="80%" persistent scrollable>
      <v-card>
        <v-card-title class="headline gradiente lighten-2 elevation-3">
          <span class="white--text">{{ title }}</span>
        </v-card-title>
        <v-card-text>
          <v-layout row wrap>
            <v-flex md4>
                &nbsp;
            </v-flex>
            <v-flex xs12 sm4 md4 lg4 xl4>
              <v-flex class="titleSearch">
                <v-text-field
                  v-model="searchText"
                  @input="filterSearch"
                  label="Buscar"
                  prepend-inner-icon="search"
                  solo-inverted
                  clearable
                />
              </v-flex>
            </v-flex>
            <v-flex md4>
                  &nbsp;
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-data-table
              style="width: 100%"
              :headers="headers"
              :items="notice.studentsAttendance"
              :custom-filter="customFilter"
              no-data-text="No hay asistencias"
              :rows-per-page-items="[10, 15, 25]"
              rows-per-page-text="Registros por página"
              no-results-text="No hay coincidencias"
              :search="filters"
              item-key="students.id"
              ref="table">
              <template
                v-slot:pageText="props"
              >{{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}</template>
            <template v-slot:headers="props">
              <th v-for="header in props.headers" :key="header.text">{{ header.text }}</th>
            </template>
            <template v-slot:items="props">
              <td class="text-xs-center" style="width: 300px">
                <v-avatar
                  :tile="tile"
                  :size="avatarSize"
                  color="grey lighten-4"
                  v-if="props.item.student.imageStorage && props.item.student.imageStorage.miniObjUrl"
                >
                  <img :src="props.item.student.imageStorage.miniObjUrl" alt="avatar" />
                </v-avatar>
                <v-avatar v-else text-color="white">
                  <v-icon>account_circle</v-icon>
                </v-avatar>
              </td>
              <td
                class="text-xs-center"
              >{{ props.item.student.firstName + " "+ props.item.student.lastName }}</td>
              <!-- //estado -->
              <td
                class="text-xs-center"
              >
              {{ getStatusAttendances(props.item) }}
              </td>
              <td class="text-xs-center">{{ props.item.date | formatDate }}</td>
            </template>
          </v-data-table>
            </v-layout>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat color="primary" @click="downloadReportAll">Descargar reporte</v-btn>
          <v-btn
            flat
            color="primary"
            v-if="isDownloadDesition"
            @click="downloadReportFiltered"
          >Descargar datos filtrados</v-btn>
          <v-btn flat color="primary" @click="close">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { noticeMixin } from "../../Mixins/NoticeReportsMixin";
import "vuex";
import { isEmptyOrNull } from '../../plugins/GeneralMethods';
export default {
  props: ["title", "notice", "value"],
  components: {},
  mixins: [noticeMixin],
  watch: {
    value() {
      this.searchText = ""
    }
  },
  mounted() {},
  data: () => ({
    modals: {
      image: false
    },
    filters: {
      search: ""
    },
    avatarSize: "30px",
    tile: false,
    userImg: null,
    working: {
      wUpdate: false,
      wImage: false
    },
    headers: [
      {
        text: "Foto",
        align: "center",
        value: "image"
      },
      {
        text: "alumno",
        align: "center",
        value: "firstName"
      },
      { text: "Estado", align: "center", value: "date" },
      { text: "Fecha y hora de confirmación", align: "center", value: "date" },
    ],
    searchText: ""
  }),
  methods: {
    submit() {},
    close() {
      this.userForm = {};
      this.$emit("input", !this.value);
    },
    customFilter(items, filters, filter, headers) {
      const cf = new this.$MultiFilters(items, filters, filter, headers);

      cf.registerFilter("search", function(searchWord, items) {
        if (searchWord == null) return items;
        
        return items.filter(item => {
          const fullname = (item.student.firstName + " " + item.student.lastName).toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
          const searchWordText = searchWord.trimEnd().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
          return (
            fullname.toLowerCase().includes(searchWordText)
          );
        }, searchWord);
      });
      return cf.runFilters();
    },
    filterSearch(val) {
      this.filters = this.$MultiFilters.updateFilters(this.filters, {
        search: val
      });
    },
    downloadReportAll() {
      this.downloadAttendanceStudent(
        this.$refs.table.items,
        this.getBranch,
        this.notice
      );
    },
    downloadReportFiltered() {
      this.downloadAttendanceStudent(
        this.$refs.table.filteredItems.slice(),
        this.getBranch,
        this.notice
      );
    },
    getStatusAttendances(item){
      if(isEmptyOrNull(item.date)){
        return "Pendiente"
      }
      return "Confirmada"
    }
  },
  computed: {
    ...mapGetters(["getBranch"]),
    isDownloadDesition() {
      return this.filters.search && this.$refs.table.filteredItems.length > 0;
    }
  }
};
</script>

<style>
.titleSearch .v-input .v-text-field .v-input__slot {
  border-radius: 33px !important;
}
</style>

<style scoped>
td,
th {
  width: 300px;
  max-width: 300px;
  min-width: 300px;
}
</style>
